class HHProductAccordionGroup extends HTMLElement {
  constructor() {
    super()

    this.openEvent = 'hh-show'
    this.accordionSelector = 'hh-product-accordion'
  }

  connectedCallback() {
    this.addEventListener(this.openEvent, this.onAccordionOpen.bind(this))
  }

  disconnectedCallback() {
    this.removeEventListener(this.openEvent, this.onAccordionOpen)
  }

  onAccordionOpen(e) {
    this.accordions = [...this.querySelectorAll(this.accordionSelector)]
    if (!this.accordions.length) return

    this.accordions.map(
      (accordion) => (accordion.open = e.target === accordion)
    )
  }
}

if (!customElements.get('hh-product-accordion-group')) {
  customElements.define('hh-product-accordion-group', HHProductAccordionGroup);
}


